import './repeatable-guest-end-date.scss';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useFetchRepeatableGuest,
  useGuestsManagementRepeatableGuestsPagination,
  useGuestsManagementRepeatableGuestsSelectedIds,
  useSetRepeatableGuestsSelectedIds,
} from '../../../store/guests-management/guestsManagementHooks';
import DatePicker from '../../shared/Datepicker';
import { Button } from 'reactstrap';
import {
  useCloseOldModal,
  useStartLoader,
  useStopLoader,
} from '../../../store/modal/modalHooks';
import GuestManagementApi from '../../../API/guests/GuestManagement.api';

export const RepeatGuestEndDateModal = () => {
  const { t } = useTranslation();
  const closeModal = useCloseOldModal();
  const selectedIds = useGuestsManagementRepeatableGuestsSelectedIds();
  const setSelectedIds = useSetRepeatableGuestsSelectedIds();
  const [selectedDate, setSelectedDate] = useState<Date>();
  const fetchGuests = useFetchRepeatableGuest();
  const startLoader = useStartLoader();
  const stopLoader = useStopLoader();
  const pagination = useGuestsManagementRepeatableGuestsPagination();

  const onClickUpdateEndDates = async () => {
    if (!selectedDate) {
      return;
    }
    startLoader();
    try {
      await GuestManagementApi.updateRepeatableGuestsEndDates({
        ids: selectedIds,
        end_date: selectedDate?.getTime(),
      });
      fetchGuests(pagination.countToShow, pagination.activePage);
      setSelectedIds([]);
      closeModal();
    } catch (error) {
      console.error(error);
    } finally {
      stopLoader();
    }
  };

  return (
    <div className="repeat-guest-end-date-modal">
      <div className="form-modal">
        <div className="form-modal-header">
          <h3>
            {t('CHANGE_VISITORS_END_DATE_TEXT', { count: selectedIds.length })}
          </h3>

          <DatePicker
            id="date"
            className="text-input"
            minDate="today"
            placeholder={t('DATE_LABEL')}
            no_clear
            value={[selectedDate || new Date()]}
            maxDate={new Date().setMonth(new Date().getMonth() + 3)}
            onChange={(e) => {
              setSelectedDate(e[0]);
            }}
          />
          <div className="repeatable-guest-end-date-modal-buttons">
            <Button color="" onClick={closeModal}>
              {t('CLOSE_BUTTON')}
            </Button>
            <Button
              className="invite-guest-button invite-guest-button-rtl"
              type="button"
              onClick={onClickUpdateEndDates}
            >
              {t('SAVE_CHANGES')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
